<template>
    <div id="packer_workspace">
        <div class="ui cards">
            <Pack
                v-for="pack in packs"
                :key="pack.identity"
                :pack="pack"
                :selected_pack="selected_pack"
                :all_packs="all_packs" />
        </div>
    </div>
</template>

<script>
import Pack from "./workspace/pack.vue"
export default {
    props: {
        packs: Array,
        selected_pack: Object,
        all_packs: Array,
        is_processing: Boolean,
    },
    data: function() {
        return {
        }
    },
    computed: {
    },
    watch: {
    },
    created: function() {
    },
    mounted: function() {
        var that = this;
    },
    methods: {
    },
    components: {
        Pack
    }
}
</script>
